<app-header [progress]="3" [title]="locale.currentTranslation.documentUploadHeader" data-testid="document-upload-header"></app-header>
<div class="base-content-container" data-testid="document-upload-container">
  <div class="headline3" data-testid="document-upload-title">{{ locale.currentTranslation.documentUpload1 }}
  </div>
  <div style="display: flex; flex-direction: column; gap: 24px;" data-testid="file-upload-categories">
    @for (fileUploadCategory of fileUploads; track fileUploadCategory; let i = $index) {
      <div style="display: flex; flex-direction: column; gap: 24px;"
           [attr.data-testid]="'upload-category-' + i">
        <div style="display: flex; flex-direction: column; gap: 16px;">
          <div>
            <div class="label1" style="margin-bottom: 4px; display: flex; justify-content: space-between" [attr.data-testid]="'category-header-' + i">
              <div [attr.data-testid]="'category-title-' + i">{{ fileUploadCategory.header }}@if (fileUploadCategory.minimumImageCount == 0) {
                <span class="caption1" style="margin-left: 2px;"
                >(optional)</span>
              }
              </div>
              <div>
                @if (fileUploadCategory.imageUrls.length < fileUploadCategory.minimumImageCount && showError) {
                  <img
                    ngSrc="assets/img/red-circle-alert.svg" height="16" width="16" [attr.data-testid]="'alert-icon-' + i" alt="Upload required">
                }
                @if (fileUploadCategory.imageUrls.length >= fileUploadCategory.minimumImageCount && showError) {
                  <img
                    ngSrc="assets/img/green-circle-check.svg" height="16" width="16" [attr.data-testid]="'check-icon-' + i" alt="Upload complete">
                }
              </div>
            </div>
            <div class="caption1" [attr.data-testid]="'category-caption-' + i">
              {{ fileUploadCategory.caption }}
            </div>
          </div>
          <div style="display: flex; gap: 16px; flex-wrap: wrap;" [attr.data-testid]="'image-gallery-' + i">
            @for (imageKey of fileUploadCategory.imageUrls; track imageKey) {
              <div
                style="position: relative; width: 56px; height: 56px;">
                <app-image class="upload-element" [src]="imageKey" [height]="56" [width]="56" [attr.data-testid]="'uploaded-image-' + i + '-' + imageKey"></app-image>
                <img
                  src="assets/img/remove-image-button.svg"
                  height="16"
                  width="16"
                  style="position: absolute; top: -4px; right: -4px; cursor: pointer;"
                  (click)="removeImage(fileUploadCategory, imageKey)"
                  [attr.data-testid]="'remove-image-' + i + '-' + imageKey"
                  role="button"
                  tabindex="0"
                  alt="Remove image"
                />
              </div>
            }
            @if (fileUploadCategory.isLoading) {
              <app-spinner data-testid="upload-spinner"/>
            } @else {
              <div class="upload-button upload-element" (click)="fileInput.value = '';triggerFileInput(i)" [attr.data-testid]="'upload-button-' + i" role="button" tabindex="0" [attr.aria-label]="'Upload images for ' + fileUploadCategory.header"></div>
            }
            <input #fileInput type="file" hidden accept="image/*"
                   (change)="onFileSelected($event, fileUploadCategory)"
                   [attr.data-testid]="'file-input-' + i"/>
          </div>
        </div>
        @if (showError && fileUploadCategory.imageUrls.length < fileUploadCategory.minimumImageCount) {
          <div class="caption1 error-text" [attr.data-testid]="'upload-error-' + i" role="alert">
            {{ locale.currentTranslation.pleaseUploadMorePhotos }}
          </div>
        }
        @if (i < fileUploads.length - 1) {
          <div class="divider" style=""></div>
        }
      </div>
    }
  </div>
  <div>
    <div (click)="expandDisclaimer = !expandDisclaimer" class="minimalistic-button" data-testid="disclaimer-toggle" role="button" tabindex="0">
      <img height="21" ngSrc="assets/img/info-icon.svg" width="20">
      <div>
        {{ locale.currentTranslation.documentUploadDisclaimerHeader }}

      </div>
      <img height="16" ngSrc="assets/img/down-carret.svg" width="16">
    </div>
    @if (expandDisclaimer) {
      <div class="text-body2" style="margin-top: 16px;" data-testid="disclaimer-content">
        {{ locale.currentTranslation.documentUploadDisclaimerText }}
      </div>
    }
  </div>
</div>
<div class="main-button-spacing">
  <button (click)="nextClicked()" class="main-button" data-testid="btn-next" role="button" tabindex="0">{{ locale.currentTranslation.next }}</button>
</div>
<app-footer data-testid="document-upload-footer"></app-footer>
